import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入 Element UI 及其样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//weiixn
import WeChatTitle from 'vue-wechat-title'
//全局注册微信分享插件
Vue.use(WeChatTitle)



Vue.config.productionTip = false

// 全局注册 Element UI
Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
